<template>
  <div class="text-center">
    <v-btn
    :dark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().accentCode" small text outlined
      @click="dialog = !dialog"
    >
    {{$store.getters.getTextMap().add_parameters}}<v-icon
      right :isDark="$store.getters.getColorPalette().isDark" :color="$store.getters.getColorPalette().btnborderColorCode" small
      >mdi-code-array
      </v-icon>
    </v-btn>
    <v-bottom-sheet v-model="dialog">
      <v-sheet
        class="text-center"
        
        
      >
      <CreateParameter :device="device" v-on:close="dialog=false"/>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import CreateParameter from '@/components/crud_components/CreateParameter'
export default {
    name:'CreateParameterBottomSheet',
    props:['device'],
    components:{
      CreateParameter  
    },
    data(){
        return {
            dialog:false
        }
    },
    methods:{
        
    }
}
</script>
